import { Button, Menu } from "@material-ui/core";
import React from "react";
import Submission from ".";
import { useTranslation } from "react-i18next";
import { KeyboardArrowDown } from "@material-ui/icons";

export default function SubmissionMenu({
  tableColDetails,
  setIsOrable,
  setTableColDetails,
  reportMeta,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { t } = useTranslation();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div
        style={{
          marginRight: "1rem",
          marginLeft: "auto",
          display: "flex",
        }}
      >
        {reportMeta.pipeline_class !== "fusion" && reportMeta.pipeline_class !== "duo" && (
          <Button
            aria-controls="simple-menu"
            aria-haspopup="true"
            color="primary"
            variant="contained"
            endIcon={<KeyboardArrowDown />}
            onClick={handleClick}
            id="clinvar-button"
          >
            {t("ClinVar")}
          </Button>
        )}
      </div>
      <Menu
        id="simple-menu"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <Submission
          id="exclude-all-benign"
          tableColDetails={tableColDetails}
          setIsOrable={setIsOrable}
          selectedValues={["P", "LP", "VUS"]}
          setTableColDetails={setTableColDetails}
          label="Exclude All Benign"
          color="primary"
        />
        <Submission
          id="include-any-pathogenic"
          tableColDetails={tableColDetails}
          setIsOrable={setIsOrable}
          selectedValues={["P", "LP"]}
          setTableColDetails={setTableColDetails}
          label="Include Any Pathogenic"
          color="secondary"
        />
      </Menu>
    </>
  );
}
